const numberWithCommas = (number) => {
  // return number?.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");//! this causes the ENTIRE app to break in Safari.
  return number?.toString();
};

export default numberWithCommas;
